export const refreshCart = () => {
    localStorage.removeItem('cart');
};